import { Download, Info } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const GUIDE = [
  ["Name", "Required", "Contact person's full name", "Ravi Sharma"],
  ["Mobile", "Required", "Any format — auto-converted to +91 E.164. Also accepts Phone / Contact Number", "09876543210 → +919876543210"],
  ["Email", "Optional", "Lower-cased and validated; used for duplicate detection", "ravi@acme.in"],
  ["Company Name", "Optional", "Similar names are flagged as possible duplicates", "Acme Logistics"],
  ["Service Required", "Optional", "Custom Software, Mobile App, Web App, Digital Marketing, Cloud & Managed IT, Telecom / HVAC IT (keywords like SEO, ERP, Android work too)", "Mobile App"],
  ["Budget", "Optional", "Numbers only, ₹ and commas are stripped", "1500000"],
  ["Source", "Optional", "Where the lead came from", "Web Form"],
];

const download = async (fmt) => {
  try {
    const r = await api.get("/import/template", { params: { format: fmt }, responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    Object.assign(document.createElement("a"), { href: url, download: `saminfratech_import_sample.${fmt}` }).click();
    URL.revokeObjectURL(url);
  } catch (e) { toast.error("Download failed"); }
};

export const ImportTemplate = () => (
  <div data-testid="import-template-card" className="rounded-3xl border border-neutral-200 bg-white p-5">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div>
        <h2 className="font-display text-base font-semibold">Sample import format</h2>
        <p className="text-sm text-neutral-500">Download the template, fill in your leads, then upload it below.</p>
      </div>
      <div className="flex gap-2">
        <button data-testid="download-template-csv" onClick={() => download("csv")} className="flex h-10 items-center gap-1.5 rounded-full bg-[#1F9E7A] px-4 text-sm font-semibold text-white"><Download className="h-4 w-4" />CSV sample</button>
        <button data-testid="download-template-xlsx" onClick={() => download("xlsx")} className="flex h-10 items-center gap-1.5 rounded-full bg-[#232323] px-4 text-sm font-semibold text-[#F5E04F]"><Download className="h-4 w-4" />Excel sample</button>
      </div>
    </div>
    <div className="mt-4 overflow-x-auto rounded-2xl border border-neutral-200">
      <table data-testid="import-template-guide" className="w-full text-xs">
        <thead className="bg-[#F6F8F5]"><tr className="text-left text-neutral-500"><th className="px-3 py-2">Column header</th><th>Need</th><th>Rules</th><th className="pr-3">Example</th></tr></thead>
        <tbody>{GUIDE.map(([h, r, d, ex]) => (
          <tr key={h} className="border-t border-neutral-200 align-top">
            <td className="px-3 py-2 font-mono font-semibold text-[#151515]">{h}</td>
            <td className="py-2"><span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${r === "Required" ? "bg-[#F7A934] text-[#151515]" : "bg-neutral-100 text-neutral-500"}`}>{r}</span></td>
            <td className="py-2 pr-3 text-neutral-600">{d}</td>
            <td className="py-2 pr-3 font-mono text-neutral-500">{ex}</td>
          </tr>))}
        </tbody>
      </table>
    </div>
    <p className="mt-3 flex items-start gap-1.5 text-xs text-neutral-500"><Info className="mt-0.5 h-3.5 w-3.5 shrink-0" />Header names don't have to match exactly — you can map any column on the next step. Rows with the same phone or email as an existing lead go to the conflict screen.</p>
  </div>
);
